export const NETWORK_ERROR = 1
export const REQUEST_ERROR = 2
export const BAD_REQUEST = 400
export const UNAUTHORIZED = 401
export const API_NOT_FOUND = 404
